import { render, staticRenderFns } from "./PriceConfigItems.vue?vue&type=template&id=3c78e4c0&"
import script from "./PriceConfigItems.vue?vue&type=script&lang=ts&"
export * from "./PriceConfigItems.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports